import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fieldParams from '../../const/fieldParams';
import { useValidatedInput } from '../../hooks/useValidatedInput';

const FirstLastNamesInput = ({ fieldKey }) => {
  const { key, type, inputMode, label, placeholder, autocomplete } = fieldParams[fieldKey];
  const { first = '', last = '' } = useSelector(({ name }) => name || {});
  const dispatch = useDispatch();

  const [value, setValue] = useState(`${first ? `${first} ` : ''}${last}`);
  const [setIsValid] = useValidatedInput('btn-view', !!first?.length || !!last?.length);

  const changeValueHandler = e => {
    const {
      target: { value },
    } = e;
    if (!value) {
      setValue('');
      dispatch({
        type: 'updateName',
        name: '',
      });
      setIsValid(false);
      return;
    }
    setValue(value);
    const [first, last] = value.split(' ');
    dispatch({
      type: 'updateName',
      name: { first, last },
    });
    setIsValid(!!value?.length);
  };

  return (
    <div className={`form-group form-group-${key}`}>
      <label htmlFor={key} className={`form-label${value === '' ? ' hidden' : ''}`}>
        {label}
      </label>
      <input
        name={key}
        id={key}
        type={type}
        inputMode={inputMode}
        className={`form-input ${key}`}
        value={value}
        onChange={changeValueHandler}
        {...(placeholder && { placeholder: placeholder })}
        {...(autocomplete && { autoComplete: autocomplete })}
      />
    </div>
  );
};

export default FirstLastNamesInput;
